import React, { useState, useEffect, useRef } from 'react';

const EditMealplanModal = ({ isOpen, onClose, onSave, editingMealplan }) => {
  const [title, setTitle] = useState('');
  const [error, setError] = useState('');
  const inputRef = useRef(null);
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      if (editingMealplan) {
        setTitle(editingMealplan.title);
      } else {
        setTitle('');
      }
      setError('');
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 0);
    }
  }, [editingMealplan, isOpen]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      } else if (event.key === 'Tab' && modalRef.current) {
        const focusableElements = Array.from(modalRef.current.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )).filter(el => el.offsetParent !== null);

        if (focusableElements.length === 0) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        const currentIndex = focusableElements.indexOf(document.activeElement);

        event.preventDefault();

        if (event.shiftKey) {
          if (currentIndex <= 0) {
            lastElement.focus();
          } else {
            focusableElements[currentIndex - 1].focus();
          }
        } else {
          if (currentIndex === -1 || currentIndex === focusableElements.length - 1) {
            firstElement.focus();
          } else {
            focusableElements[currentIndex + 1].focus();
          }
        }
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, editingMealplan, onClose]);

  if (!isOpen) return null;

  const handleSave = async () => {
    if (!title) {
      setError('Meal plan title cannot be empty');
      return;
    }
    const response = await onSave({ ...editingMealplan, title });
    if (response && response.error) {
      setError(response.error);
    } else {
      setError('');
      onClose();
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" ref={modalRef}>
        <div className="modal-header">
          <h2><i className="material-icons" style={{ marginRight: '5px', verticalAlign: 'top' }}>event_note</i>Edit Meal Plan</h2>
          <button title="Close" onClick={onClose} className="icon-button close-button"><i className="material-icons">close</i></button>
        </div>
        <div className="modal-body">
          {error && <p className="error-message">{error}</p>}
          <div className="search-input-container">
            <input
              ref={inputRef}
              type="text"
              placeholder="Meal Plan Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSave()}
            />
            {title && <button title="Clear title" type="button" onClick={() => { setTitle(''); inputRef.current.focus(); }} className="clear-input-button"><i className="material-icons">close</i></button>}
          </div>
        </div>
        <div className="modal-footer">
          <button title="Save" onClick={handleSave}>Save</button>
          <button title="Cancel" onClick={onClose} className="cancel-button">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default EditMealplanModal;